import { Outlet } from 'react-router-dom';

import { ConversationsSidebar } from '@web/conversations/ConversationsSidebar/ConversationsSidebar';
import { QuickSearch } from '@web/conversations/QuickSearch/QuickSearch';

import { NotificationRequestBanner } from './components/NotificationRequestBanner/NotificationRequestBanner';
import {
  ContentWrapper,
  InnerWrapper,
  OuterWrapper,
  SidebarWrapper,
} from './conversationView.styles';

export const ConversationView = () => (
  <>
    <OuterWrapper>
      <NotificationRequestBanner />

      <InnerWrapper>
        <SidebarWrapper>
          <ConversationsSidebar />
        </SidebarWrapper>

        <ContentWrapper>
          <Outlet />
        </ContentWrapper>
      </InnerWrapper>
    </OuterWrapper>

    <QuickSearch />
  </>
);
